import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import {
  selectCurrentVariantSteps,
  selectCurrentVariantStepsV2,
  selectGrowthbookFeatureKey,
} from 'root-redux/selects/common'

import { useActiveLanguage } from 'hooks/useActiveLanguage'
import { useExperimentalFeatures } from 'hooks/useExperimentalFeatures'
import { useStepsVariant } from 'hooks/useStepsVariant'

import { isTestGroup } from 'helpers/isTestGroup'

import { IStep } from 'models/variant.model'

import { PageId } from 'page-constants'

export const useActiveSteps = (): IStep[] => {
  const steps = useSelector(selectCurrentVariantSteps)
  const stepsV2 = useSelector(selectCurrentVariantStepsV2)
  const growthbookFeatureKey = useSelector(selectGrowthbookFeatureKey)
  const { isArLanguage } = useActiveLanguage()
  const { ayah123DiscountVariant } = useExperimentalFeatures()

  const stepsVariant = useStepsVariant()

  const variantSteps: IStep[] | undefined = stepsV2[stepsVariant]

  const cohortSteps =
    growthbookFeatureKey && variantSteps?.length ? variantSteps : steps
  const isAyah123TestGroup = isTestGroup(ayah123DiscountVariant)

  return useMemo(
    () =>
      cohortSteps.filter(({ id }) => {
        if (isArLanguage && id === PageId.TRANSLATION_QURAN) return false
        if (isAyah123TestGroup && id === PageId.SCRATCH_CARD) return false

        return true
      }),
    [cohortSteps, isArLanguage, isAyah123TestGroup],
  )
}
